(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r = [], n = false, o = null;
  const a = (e2) => Date.now() - e2 > 3e5, i = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: n2 }) => {
    try {
      const o2 = `https://${e2}/api/2024-07/graphql.json`, a2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, i2 = await fetch(o2, { method: "POST", headers: a2, body: JSON.stringify({ query: r2, variables: n2 }) });
      return await i2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, c = async (i2, c2, l2, u2, p2, d2) => {
    const y2 = ((e2, t2, r2, n2, o2) => `${e2}:${t2}:${r2}:${JSON.stringify(n2)}:${o2}`)(i2, l2, u2, p2, d2), m2 = e.get(y2);
    if (m2 && !a(m2.timestamp)) return m2.data;
    const f2 = t.get(y2);
    if (f2) return f2;
    const g2 = (h2 = { shopDomain: i2, accessToken: c2, handle: l2, customerGroupId: u2, customerTags: p2, clayCountryIsoCode: d2, cacheKey: y2 }, new Promise((e2, t2) => {
      r.push({ ...h2, resolve: e2, reject: t2 }), n || (n = true, queueMicrotask(() => {
        n = false, function() {
          if (0 === r.length) return;
          const e3 = r;
          r = [];
          for (let t3 = 0; t3 < e3.length; t3 += 10) {
            const r2 = e3.slice(t3, t3 + 10), n2 = null === o, a2 = s(r2, n2);
            n2 && (o = a2);
          }
        }();
      }));
    }));
    var h2;
    return t.set(y2, g2), g2.finally(() => {
      t.delete(y2);
    }), g2;
  };
  async function s(t2, r2) {
    var _a, _b, _c;
    if (!r2 && o) try {
      await o;
    } catch {
    }
    const n2 = t2[0];
    try {
      const r3 = `query batchProductMetafield($country: CountryCode) @inContext(country: $country) {
    ${t2.map((e2) => e2.handle).map((e2, t3) => `p${t3}: product(handle: ${JSON.stringify(e2)}) {
      title
      handle
      variants(first: 250) {
        edges {
          node {
            id
            title
            metafield(namespace: "app--173437812737--clay", key: "pricing_rule") {
              value
              type
            }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            availableForSale
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }`).join("\n")}
  }`, o2 = await i({ shopDomain: n2.shopDomain, accessToken: n2.accessToken, query: r3, variables: { country: n2.clayCountryIsoCode } });
      if (!(o2 == null ? void 0 : o2.data)) {
        const e2 = new Error("Empty response from Storefront API");
        return void t2.forEach((t3) => t3.reject(e2));
      }
      for (let r4 = 0; r4 < t2.length; r4++) {
        const n3 = t2[r4], a2 = o2.data[`p${r4}`];
        if (!a2) {
          const t3 = { handle: n3.handle, allVariants: [] };
          e.set(n3.cacheKey, { data: t3, timestamp: Date.now() }), n3.resolve(t3);
          continue;
        }
        if ((_b = (_a = a2.variants) == null ? void 0 : _a.pageInfo) == null ? void 0 : _b.hasNextPage) {
          u(n3.shopDomain, n3.accessToken, n3.handle, n3.customerGroupId, n3.customerTags, n3.clayCountryIsoCode, n3.cacheKey).then((e2) => n3.resolve(e2)).catch(n3.reject);
          continue;
        }
        const i2 = (((_c = a2.variants) == null ? void 0 : _c.edges) || []).map((e2) => l(e2.node, n3.customerGroupId, n3.customerTags)), c2 = { handle: n3.handle, allVariants: i2 };
        e.set(n3.cacheKey, { data: c2, timestamp: Date.now() }), n3.resolve(c2);
      }
      p();
    } catch (e2) {
      console.error("Error in batched product metafield fetch:", e2), t2.forEach((t3) => t3.reject(e2));
    }
  }
  function l(e2, t2, r2) {
    var _a;
    const n2 = e2.id.split("/").pop(), o2 = (_a = e2.metafield) == null ? void 0 : _a.value, a2 = function(e3) {
      if (!Array.isArray(e3) || 0 === e3.length) return [];
      const t3 = e3[0];
      if ("customerGroupId" in t3) return r3 = e3, Array.isArray(r3) ? r3.map((e4 = {}) => {
        const { customerGroupId: t4 = "", customerTag: r4 = "", type: n3 = "WHOLESALE", wholesalePrice: o3 = null, quantityPrice: a3 = {} } = e4;
        let i3 = false;
        "QUANTITY" === n3 && (i3 = !!a3.isVariantUnique);
        let c3 = [];
        return "WHOLESALE" === n3 && null != o3 ? c3.push({ quantity: "1", price: o3 }) : Array.isArray(a3.value) && (c3 = a3.value), { ownerId: "", customerGroupId: t4, customerTag: r4, markets: [{ handle: "", currency: "", pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: i3, priceSource: "R", values: c3 } }] };
      }) : [];
      var r3;
      if ("i" in t3) return function(e4) {
        if (!e4 || !Array.isArray(e4)) return null;
        const t4 = e4.map((e5 = {}) => {
          let t5 = e5.o || "", [r4 = "", n3 = ""] = (e5.i || "").split("~"), o3 = e5.p.split("|").map((e6) => {
            let [t6 = "", r5 = "", n4 = "A", o4 = "0", a3 = "R", i3 = ""] = e6.split("~"), c3 = i3.split(";").map((e7) => {
              let [t7 = "1", r6 = "0"] = e7.split(":");
              return { quantity: t7, price: r6 };
            }) ?? [];
            return { handle: t6, currency: r5, pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n4, priceSource: a3, isVariantUnique: "1" === o4, values: c3 } };
          });
          return { ownerId: t5, customerGroupId: r4, customerTag: n3, markets: o3 };
        });
        return t4;
      }(e3);
      return [];
    }("string" == typeof o2 ? JSON.parse(o2) : []);
    let i2 = a2.find((e3) => e3.customerGroupId === t2 && !["LOGGED_IN", "ALL"].includes(t2) || r2.includes(e3.customerTag));
    i2 || "ALL" === t2 || (i2 = a2.find((e3) => "LOGGED_IN" === e3.customerGroupId)), i2 || (i2 = a2.find((e3) => "ALL" === e3.customerGroupId));
    const c2 = window.clayMarketHandle;
    if (i2) {
      const t3 = i2.markets.find((e3) => e3.handle === c2 || "" === e3.handle) || null;
      if (t3) {
        const r3 = { ...i2, markets: [t3] };
        if ("" === r3.ownerId || r3.ownerId === n2.split("/").pop()) return { id: n2, title: e2.title, pricingRule: r3, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
      }
    }
    return { id: n2, title: e2.title, pricingRule: null, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
  }
  async function u(t2, r2, n2, o2, a2, c2, s2) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    try {
      let u2, d2 = true;
      const y2 = [];
      for (; d2; ) {
        const p2 = await i({ shopDomain: t2, accessToken: r2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250, after: ${u2 ? `"${u2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                    availableForSale
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: n2, country: c2 } });
        if (!((_a = p2.data) == null ? void 0 : _a.product)) {
          const t3 = { handle: n2, allVariants: [] };
          return e.set(s2, { data: t3, timestamp: Date.now() }), t3;
        }
        const m3 = (((_b = p2.data.product.variants) == null ? void 0 : _b.edges) || []).map((e2) => l(e2.node, o2, a2));
        y2.push(...m3), d2 = (_f = (_e = (_d = (_c = p2.data) == null ? void 0 : _c.product) == null ? void 0 : _d.variants) == null ? void 0 : _e.pageInfo) == null ? void 0 : _f.hasNextPage, u2 = (_j = (_i = (_h = (_g = p2.data) == null ? void 0 : _g.product) == null ? void 0 : _h.variants) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.endCursor;
      }
      const m2 = { handle: n2, allVariants: y2 };
      return e.set(s2, { data: m2, timestamp: Date.now() }), p(), m2;
    } catch (e2) {
      throw console.error("Error fetching product metafield:", e2), e2;
    }
  }
  const p = () => {
    for (const [t2, r2] of e.entries()) a(r2.timestamp) && e.delete(t2);
  };
  function d(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, n2 = r2.toFixed(2), o2 = r2.toFixed(0), a2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), i2 = o2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), s2 = o2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = n2.replace(".", ","), u2 = a2.replace(/(\d+)\.(\d{2})$/, "$1,$2"), p2 = c2.replace(/(\d+)\.(\d{2})$/, "$1,$2");
    return t2.replace("{{amount}}", n2).replace("{{amount_no_decimals}}", o2).replace("{{amount_with_comma_separator}}", a2).replace("{{amount_no_decimals_with_comma_separator}}", i2).replace("{{amount_with_period_separator}}", c2).replace("{{amount_no_decimals_with_period_separator}}", s2).replace("{{amount_with_comma_decimal}}", l2).replace("{{amount_with_comma_separator_and_comma_decimal}}", u2).replace("{{amount_with_period_separator_and_comma_decimal}}", p2);
  }
  function y(e2, t2, r2) {
    var _a;
    let n2 = "", o2 = "", a2 = "", i2 = "", c2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!c2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let s2 = c2.pricing.type;
    return "QUANTITY" === s2 ? { retailPriceText: n2, compareAtPriceText: o2, savingsText: a2, maxRetailPriceText: i2 } = function(e3, t3, r3, n3) {
      let o3 = n3.pricing.strategy, a3 = n3.pricing.values, i3 = n3.currency, c3 = e3.price.currencyCode, s3 = "R" === n3.pricing.priceSource ? e3.price.amount : "C" === n3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l2 = window.marketConversionRate;
      if (!s3 || "" === s3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let u2 = a3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (i3 !== c3 && "" !== i3) {
        if (!l2 || !l2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(o3) && (u2 = (parseFloat(u2) * l2.conversion_rate).toFixed(2).toString());
      }
      let p2 = "A" === o3 ? u2 : "P" === o3 ? (parseFloat(s3) * (1 - parseFloat(u2) / 100)).toFixed(2).toString() : "F" === o3 ? (parseFloat(s3) - parseFloat(u2)).toFixed(2).toString() : e3.price.amount;
      if ("" === i3 && l2 && l2.base_currency !== c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(p2) < 0 || parseFloat(p2) > parseFloat(e3.price.amount)) && (p2 = e3.price.amount);
      let y2 = d(p2, clayProductPriceConfig.priceDisplayText), m2 = d(s3, clayProductPriceConfig.compareAtPriceDisplayText), f2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(s3) - parseFloat(p2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(s3) - parseFloat(p2)) / parseFloat(s3) * 100).toFixed(2) : 0, g2 = d(f2, clayProductPriceConfig.savingsDisplayText);
      return l2 && (y2 = window.clayCurrencySymbol + parseFloat(p2).toFixed(2) + " " + window.clayCountryCurrency, m2 = window.clayCurrencySymbol + parseFloat(s3).toFixed(2) + " " + window.clayCountryCurrency, g2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + f2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? f2 + "%" : "")), { retailPriceText: y2, compareAtPriceText: m2, savingsText: g2, maxRetailPriceText: "" };
    }(e2, 0, r2, c2) : "WHOLESALE" === s2 && ({ retailPriceText: n2, compareAtPriceText: o2, savingsText: a2, maxRetailPriceText: i2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy;
      r3.pricing.values;
      let o3 = r3.currency, a3 = e3.price.currencyCode, i3 = window.marketConversionRate, c3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s3 = r3.pricing.values[0].price;
      if (!c3 || "" === c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (o3 !== a3 && "" !== o3) {
        if (!i3 || !i3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (s3 = (parseFloat(s3) * i3.conversion_rate).toFixed(2).toString());
      }
      let l2 = "A" === n3 ? s3 : "P" === n3 ? (parseFloat(c3) * (1 - parseFloat(s3) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c3) - parseFloat(s3)).toFixed(2).toString() : e3.price.amount;
      if ("" === o3 && i3 && i3.base_currency !== a3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(l2) < 0 || parseFloat(l2) > parseFloat(e3.price.amount)) && (l2 = e3.price.amount);
      let u2 = d(l2, clayProductPriceConfig.priceDisplayText), p2 = d(c3, clayProductPriceConfig.compareAtPriceDisplayText), y2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(l2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(l2)) / parseFloat(c3) * 100).toFixed(2) : 0, m2 = d(y2, clayProductPriceConfig.savingsDisplayText);
      return i3 && (u2 = window.clayCurrencySymbol + parseFloat(l2).toFixed(2) + " " + window.clayCountryCurrency, p2 = window.clayCurrencySymbol + parseFloat(c3).toFixed(2) + " " + window.clayCountryCurrency, m2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + y2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? y2 + "%" : "")), { retailPriceText: u2, compareAtPriceText: p2, savingsText: m2, maxRetailPriceText: "" };
    }(e2, 0, c2)), { retailPriceText: n2, compareAtPriceText: o2, savingsText: a2, maxRetailPriceText: i2 };
  }
  function m(e2) {
    if (!e2 || "" === e2) return null;
    let t2 = null;
    const r2 = e2.match(/\/products\/([^/?#]+)/);
    return r2 && r2[1] && (t2 = decodeURIComponent(r2[1])), t2;
  }
  async function f(e2) {
    const t2 = window.clayStorefrontConfig || {}, r2 = window.clayCustomerTier || {}, n2 = window.clayCustomerTags || [], o2 = window.clayCountryIsoCode, { allVariants: a2 } = await c(t2.shopDomain, t2.token, e2, "" === r2.customerGroupId ? "LOGGED_IN" : r2.customerGroupId, n2, o2);
    return a2;
  }
  const g = "%[a-f0-9]{2}", h = new RegExp("(" + g + ")|([^%]+?)", "gi"), x = new RegExp("(" + g + ")+", "gi");
  function v(e2, t2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    t2 = t2 || 1;
    const r2 = e2.slice(0, t2), n2 = e2.slice(t2);
    return Array.prototype.concat.call([], v(r2), v(n2));
  }
  function w(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let t2 = e2.match(h) || [];
      for (let r2 = 1; r2 < t2.length; r2++) t2 = (e2 = v(t2, r2).join("")).match(h) || [];
      return e2;
    }
  }
  function T(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const t2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let r2 = x.exec(e3);
        for (; r2; ) {
          try {
            t2[r2[0]] = decodeURIComponent(r2[0]);
          } catch {
            const e4 = w(r2[0]);
            e4 !== r2[0] && (t2[r2[0]] = e4);
          }
          r2 = x.exec(e3);
        }
        t2["%C2"] = "�";
        const n2 = Object.keys(t2);
        for (const r3 of n2) e3 = e3.replace(new RegExp(r3, "g"), t2[r3]);
        return e3;
      }(e2);
    }
  }
  function P(e2, t2) {
    const r2 = {};
    if (Array.isArray(t2)) for (const n2 of t2) {
      const t3 = Object.getOwnPropertyDescriptor(e2, n2);
      (t3 == null ? void 0 : t3.enumerable) && Object.defineProperty(r2, n2, t3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const o2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (o2.enumerable) {
        t2(n2, e2[n2], e2) && Object.defineProperty(r2, n2, o2);
      }
    }
    return r2;
  }
  function C(e2, t2) {
    if ("string" != typeof e2 || "string" != typeof t2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === t2) return [];
    const r2 = e2.indexOf(t2);
    return -1 === r2 ? [] : [e2.slice(0, r2), e2.slice(r2 + t2.length)];
  }
  const b = Symbol("encodeFragmentIdentifier");
  function F(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function S(e2, t2) {
    return t2.encode ? t2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function A(e2, t2) {
    return t2.decode ? T(e2) : e2;
  }
  function _(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? _(Object.keys(e2)).sort((e3, t2) => Number(e3) - Number(t2)).map((t2) => e2[t2]) : e2;
  }
  function I(e2) {
    const t2 = e2.indexOf("#");
    return -1 !== t2 && (e2 = e2.slice(0, t2)), e2;
  }
  function k(e2, t2, r2) {
    return "string" === r2 && "string" == typeof e2 ? e2 : "function" == typeof r2 && "string" == typeof e2 ? r2(e2) : !t2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== r2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? t2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function j(e2) {
    const t2 = (e2 = I(e2)).indexOf("?");
    return -1 === t2 ? "" : e2.slice(t2 + 1);
  }
  function O(e2, t2) {
    F((t2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...t2 }).arrayFormatSeparator);
    const r2 = function(e3) {
      let t3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, r3, n3) => {
            t3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), t3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][t3[1]] = r3) : n3[e4] = r3;
          };
        case "bracket":
          return (e4, r3, n3) => {
            t3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "colon-list-separator":
          return (e4, r3, n3) => {
            t3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "comma":
        case "separator":
          return (t4, r3, n3) => {
            const o2 = "string" == typeof r3 && r3.includes(e3.arrayFormatSeparator), a2 = "string" == typeof r3 && !o2 && A(r3, e3).includes(e3.arrayFormatSeparator);
            r3 = a2 ? A(r3, e3) : r3;
            const i2 = o2 || a2 ? r3.split(e3.arrayFormatSeparator).map((t5) => A(t5, e3)) : null === r3 ? r3 : A(r3, e3);
            n3[t4] = i2;
          };
        case "bracket-separator":
          return (t4, r3, n3) => {
            const o2 = /(\[])$/.test(t4);
            if (t4 = t4.replace(/\[]$/, ""), !o2) return void (n3[t4] = r3 ? A(r3, e3) : r3);
            const a2 = null === r3 ? [] : A(r3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[t4] ? n3[t4] = [...n3[t4], ...a2] : n3[t4] = a2;
          };
        default:
          return (e4, t4, r3) => {
            void 0 !== r3[e4] ? r3[e4] = [...[r3[e4]].flat(), t4] : r3[e4] = t4;
          };
      }
    }(t2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const o2 of e2.split("&")) {
      if ("" === o2) continue;
      const e3 = t2.decode ? o2.replaceAll("+", " ") : o2;
      let [a2, i2] = C(e3, "=");
      void 0 === a2 && (a2 = e3), i2 = void 0 === i2 ? null : ["comma", "separator", "bracket-separator"].includes(t2.arrayFormat) ? i2 : A(i2, t2), r2(A(a2, t2), i2, n2);
    }
    for (const [e3, r3] of Object.entries(n2)) if ("object" == typeof r3 && null !== r3 && "string" !== t2.types[e3]) for (const [n3, o2] of Object.entries(r3)) {
      const a2 = t2.types[e3] ? t2.types[e3].replace("[]", "") : void 0;
      r3[n3] = k(o2, t2, a2);
    }
    else "object" == typeof r3 && null !== r3 && "string" === t2.types[e3] ? n2[e3] = Object.values(r3).join(t2.arrayFormatSeparator) : n2[e3] = k(r3, t2, t2.types[e3]);
    return false === t2.sort ? n2 : (true === t2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(t2.sort)).reduce((e3, t3) => {
      const r3 = n2[t3];
      return e3[t3] = Boolean(r3) && "object" == typeof r3 && !Array.isArray(r3) ? _(r3) : r3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function R(e2, t2) {
    if (!e2) return "";
    F((t2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...t2 }).arrayFormatSeparator);
    const r2 = (r3) => t2.skipNull && null == e2[r3] || t2.skipEmptyString && "" === e2[r3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (t3) => (r3, n3) => {
            const o3 = r3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [S(t3, e3), "[", o3, "]"].join("")] : [...r3, [S(t3, e3), "[", S(o3, e3), "]=", S(n3, e3)].join("")];
          };
        case "bracket":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [S(t3, e3), "[]"].join("")] : [...r3, [S(t3, e3), "[]=", S(n3, e3)].join("")];
        case "colon-list-separator":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [S(t3, e3), ":list="].join("")] : [...r3, [S(t3, e3), ":list=", S(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const t3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (r3) => (n3, o3) => void 0 === o3 || e3.skipNull && null === o3 || e3.skipEmptyString && "" === o3 ? n3 : (o3 = null === o3 ? "" : o3, 0 === n3.length ? [[S(r3, e3), t3, S(o3, e3)].join("")] : [[n3, S(o3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, S(t3, e3)] : [...r3, [S(t3, e3), "=", S(n3, e3)].join("")];
      }
    }(t2), o2 = {};
    for (const [t3, n3] of Object.entries(e2)) r2(t3) || (o2[t3] = n3);
    const a2 = Object.keys(o2);
    return false !== t2.sort && a2.sort(t2.sort), a2.map((r3) => {
      const o3 = e2[r3];
      return void 0 === o3 ? "" : null === o3 ? S(r3, t2) : Array.isArray(o3) ? 0 === o3.length && "bracket-separator" === t2.arrayFormat ? S(r3, t2) + "[]" : o3.reduce(n2(r3), []).join("&") : S(r3, t2) + "=" + S(o3, t2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function E(e2, t2) {
    var _a;
    t2 = { decode: true, ...t2 };
    let [r2, n2] = C(e2, "#");
    return void 0 === r2 && (r2 = e2), { url: ((_a = r2 == null ? void 0 : r2.split("?")) == null ? void 0 : _a[0]) ?? "", query: O(j(e2), t2), ...t2 && t2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: A(n2, t2) } : {} };
  }
  function N(e2, t2) {
    t2 = { encode: true, strict: true, [b]: true, ...t2 };
    const r2 = I(e2.url).split("?")[0] || "";
    let n2 = R({ ...O(j(e2.url), { sort: false }), ...e2.query }, t2);
    n2 && (n2 = `?${n2}`);
    let o2 = function(e3) {
      let t3 = "";
      const r3 = e3.indexOf("#");
      return -1 !== r3 && (t3 = e3.slice(r3)), t3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(r2);
      n3.hash = e2.fragmentIdentifier, o2 = t2[b] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${r2}${n2}${o2}`;
  }
  function L(e2, t2, r2) {
    r2 = { parseFragmentIdentifier: true, [b]: false, ...r2 };
    const { url: n2, query: o2, fragmentIdentifier: a2 } = E(e2, r2);
    return N({ url: n2, query: P(o2, t2), fragmentIdentifier: a2 }, r2);
  }
  const D = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, t2, r2) {
    return L(e2, Array.isArray(t2) ? (e3) => !t2.includes(e3) : (e3, r3) => !t2(e3, r3), r2);
  }, extract: j, parse: O, parseUrl: E, pick: L, stringify: R, stringifyUrl: N }, Symbol.toStringTag, { value: "Module" })), q = window.clayStorefrontConfig || {}, U = window.clayCustomerTags || [], G = window.clayMarketHandle, M = window.clayCountryCurrency, H = window.clayCountryIsoCode, V = "clay-wholesale-price", B = ".smi-product-card", J = "a[href*='/products/']", K = ".smi-price";
  async function W() {
    m(window.location.href) && Q(0, 4e3);
  }
  async function Q(e2, t2) {
    const r2 = m(window.location.href);
    if (!r2) return;
    const n2 = document.querySelector('[id^="product_price_content_"]');
    if (!n2) return void (e2 < t2 && setTimeout(() => Q(e2 + 250, t2), 250));
    const o2 = await f(r2);
    if (!o2 || 0 === o2.length) return;
    const a2 = new URL(window.location.href);
    let i2 = D.parse(a2.search).variant;
    if (!i2) {
      const e3 = o2.find((e4) => e4.availableForSale);
      i2 = (e3 || o2[0]).id;
    }
    const c2 = o2.find((e3) => e3.id === i2) || o2[0];
    if (!c2.pricingRule) return;
    const { retailPriceText: s2, compareAtPriceText: l2 } = y(c2, 0, 1);
    s2 && (function(e3, t3, r3) {
      const n3 = function(e4, t4) {
        const r4 = t4 && t4 !== e4;
        if (r4) return `<div class="price-sale"><span class="listed-price smi-text-price-lg">${t4}</span><span class="sale-price smi-text-price-xl">${e4}</span></div>`;
        return `<div class="price-sale smi-text-price-xl">${e4}</div>`;
      }(t3, r3);
      if (e3.innerHTML === n3) return;
      const o3 = e3._clayObserver;
      o3 && o3.disconnect();
      e3.innerHTML = n3, e3.classList.add(V), o3 && o3.observe(e3, { childList: true, subtree: true });
    }(n2, s2, l2), function(e3) {
      if (e3._clayObserver) return;
      const t3 = new MutationObserver(() => {
        e3.classList.contains(V) || Q(0, 0);
      });
      e3._clayObserver = t3, t3.observe(e3, { childList: true, subtree: true });
      const r3 = new MutationObserver(() => {
        e3.classList.remove(V);
      });
      r3.observe(e3, { childList: true });
    }(n2));
  }
  function Y(e2, t2) {
    const r2 = Array.from(document.querySelectorAll(B)).filter((e3) => {
      const t3 = e3.querySelector(K);
      return t3 && !t3.classList.contains(V);
    });
    r2.length > 0 && function(e3) {
      e3.forEach(async (e4) => {
        var _a;
        const t3 = e4.querySelector(K);
        if (!t3 || t3.classList.contains(V)) return;
        t3.classList.add(V);
        const r3 = (_a = e4.querySelector(J)) == null ? void 0 : _a.href;
        if (!r3) return;
        const n2 = m(r3);
        if (!n2) return;
        const o2 = await f(n2);
        o2 && 0 !== o2.length && function(e5, t4) {
          e5.sort((e6, t5) => parseFloat(e6.price.amount) - parseFloat(t5.price.amount));
          const r4 = e5[0];
          if (!r4.pricingRule) return;
          const { retailPriceText: n3, compareAtPriceText: o3 } = y(r4, 0, 1);
          if (!n3) return;
          let a2 = "";
          o3 && o3 !== n3 && (a2 += '<span class="smi-price__origin smi-text-price-md smi-color-text-55 smi-text-decoration-line-through">' + o3 + "</span>");
          a2 += '<span class="smi-price__sale smi-text-price-md smi-color-text">' + n3 + "</span>", t4.innerHTML = a2;
        }(o2, t3);
      });
    }(r2), e2 < t2 && setTimeout(() => Y(e2 + 250, t2), 250);
  }
  !async function() {
    await async function() {
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { customer_tags: (U == null ? void 0 : U.join(",")) || "" } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
      let e2 = null;
      const t2 = await (async (e3, t3, r2) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let n2 = null, o2 = null, a2 = null, c2 = null;
        try {
          const s2 = await i({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts($country: CountryCode) @inContext(country: $country) {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }", variables: { country: r2 } });
          ((_c = (_b = (_a = s2 == null ? void 0 : s2.data) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.length) > 0 && (n2 = (_d = s2.data.products.edges[0].node.variants) == null ? void 0 : _d.edges[0].node.price);
          const l2 = await i({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }" });
          if (((_g = (_f = (_e = l2 == null ? void 0 : l2.data) == null ? void 0 : _e.products) == null ? void 0 : _f.edges) == null ? void 0 : _g.length) > 0 && (o2 = (_h = l2.data.products.edges[0].node.variants) == null ? void 0 : _h.edges[0].node.price), n2 && o2) {
            const e4 = o2.currencyCode;
            e4 !== n2.currencyCode && (c2 = (parseFloat(n2.amount) / parseFloat(o2.amount)).toFixed(8), a2 = e4);
          }
          return { conversionRate: c2, baseCurrency: a2 };
        } catch (e4) {
          return console.error("Error fetching conversion rate:", e4), { conversionRate: null, baseCurrency: null };
        }
      })(q.shopDomain, q.token, H);
      t2.conversionRate && (e2 = { conversion_rate: t2.conversionRate, base_currency: t2.baseCurrency, market_handle: G, market_currency: M });
      window.marketConversionRate = e2, e2 && fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { market_conversion_rate: JSON.stringify(e2) } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
    }(), function() {
      window.addEventListener("popstate", W);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), W();
      };
      const t2 = history.replaceState;
      history.replaceState = function() {
        t2.apply(this, arguments), W();
      }, W();
    }(), function() {
      Y(0, 4e3);
      new MutationObserver((e2) => {
        var _a, _b;
        for (const t2 of e2) for (const e3 of t2.addedNodes) if (1 === e3.nodeType && (((_a = e3.matches) == null ? void 0 : _a.call(e3, B)) || ((_b = e3.querySelector) == null ? void 0 : _b.call(e3, B)))) return void Y(0, 0);
      }).observe(document.body, { childList: true, subtree: true });
    }();
  }();
}();
